export default function Clock() {
  return <>Clock</>;
}
